"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterPage = void 0;
const footer_1 = require("@components/footer");
const header_1 = require("@components/header");
const collections_page_1 = require("@pages/collections-page");
const tokens_page_1 = require("@pages/tokens-page");
const users_page_1 = require("@pages/users-page");
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
require("./styles.scss");
const MasterPage = (props) => {
    return (React.createElement("div", { className: "p-master-page" },
        React.createElement(header_1.Header, null),
        React.createElement("div", { className: "p-master-page__content" },
            React.createElement("div", { className: "p-master-page__grid" },
                React.createElement(react_router_dom_1.Redirect, { to: "/tokens" }),
                React.createElement(react_router_dom_1.Switch, null,
                    React.createElement(react_router_dom_1.Route, { path: "/tokens", component: tokens_page_1.TokensPage }),
                    React.createElement(react_router_dom_1.Route, { path: "/collections", component: collections_page_1.CollectionsPage }),
                    React.createElement(react_router_dom_1.Route, { path: "/users", component: users_page_1.UsersPage })))),
        React.createElement(footer_1.Footer, null)));
};
exports.MasterPage = MasterPage;
